import SectionLabel from "@/components/base/SectionLabel";
import { aiDigitalData } from "@/mocks/aiDigitalData";

export default function ChallengesSection() {
  return (
    <section className="py-14 md:py-18 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-8">
        <div className="text-center mb-8 md:mb-12 reveal">
          <SectionLabel
            label={aiDigitalData.challenges.label}
            className="mb-3"
          />
          <h2 className="font-heading text-xl md:text-2xl lg:text-3xl font-bold text-foreground-900 leading-[1.5]">
            {aiDigitalData.challenges.title}
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4 max-w-5xl mx-auto">
          {aiDigitalData.challenges.items.map((item, idx) => (
            <div
              key={idx}
              className="reveal flex items-start gap-3 p-4 md:p-5 rounded-lg bg-background-50 border border-background-200/50 transition-colors"
              style={{ transitionDelay: `${idx * 80}ms` }}
            >
              <div className="w-8 h-8 rounded-lg bg-primary-500/10 flex items-center justify-center flex-shrink-0 mt-0.5">
                <i className={`${item.icon} text-primary-500`} />
              </div>
              <div>
                <h3 className="text-sm font-bold text-foreground-900 mb-1 font-heading leading-snug">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}